import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService, ToastService } from '@core';
import * as regular from '@fortawesome/free-regular-svg-icons';
import * as solid from '@fortawesome/free-solid-svg-icons';
import { MenuHeaderTopic } from '@ui';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { GroupBaselineService } from '../data-access/group-baseline.service';

@Component({
  selector: 'app-notification-log-group-baseline',
  templateUrl: './notification-log-group-baseline.component.html',
  styleUrls: ['./notification-log-group-baseline.component.scss'],
})
export class NotificationLogGroupBaselineComponent
  implements OnInit, AfterViewInit
{
  iconsolid = solid;
  iconregular = regular;

  location_site: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('inputFilter') inputFilter!: ElementRef;

  historyTopic: MenuHeaderTopic = {
    title: 'view_value.baseline_history',
    subtitle: `view_value.list_group_baseline`,
    iconUrl: `assets/shared/icons/baseline.svg`,
  };
  displayedColumns: string[] = [
    'no',
    'name',
    'message',
    'setpoint_value',
    'time',
    'type',
    'value',
  ];

  dataSource!: MatTableDataSource<any[]>;

  length: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageIndex: number = 0;
  pageEvent!: PageEvent;

  dialogRef: any;

  onDownload: boolean = true;

  groupNameList: string[] = [];
  set groupNameSelected(groupNameValue: string) {
    let data = this.dataTable.filter(
      (value) => value.name == groupNameValue || groupNameValue == 'all',
    );
    let data_map: any[] = [];
    data.forEach((data_value: any) =>
      data_value.notifications.forEach((notifications_data: any) => {
        data_map.push({
          name: data_value.name,
          ...notifications_data,
        });
      }),
    );
    this.dataSource = new MatTableDataSource(data_map);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private rest: GroupBaselineService,
    public dialog: MatDialog,
    public dialogServcie: DialogService,
    public toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.loadBaselineLog();
  }

  ngAfterViewInit() {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  dataTable: any[] = [];

  loadBaselineLog() {
    this.dialogServcie.withLoading(this.rest.getBaselineLog()).subscribe({
      next: (response) => {
        if (response.meta.response_code === 20000) {
          this.groupNameList = [];
          this.dataTable = response.meta.response_data.baseline_group;
          let data_map: any[] = [];
          this.dataTable.forEach((data: any) => {
            this.groupNameList.push(data.name);
            data.notifications.forEach((notifications_data: any) => {
              data_map.push({
                name: data.name,
                ...notifications_data,
              });
            });
          });
          this.dataSource = new MatTableDataSource(data_map);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        } else {
          this.toast.error('เกิดข้อผิดพลาด');
        }
      },
      error: (e) => {
        console.error(e);
        this.toast.error('เกิดข้อผิดพลาด');
      },
    });
  }

  onExportCSV() {
    try {
      var options = {
        showLabels: true,
        headers: this.displayedColumns,
        useHeader: true,
      };
      let data = this.dataSource.filteredData.map((v: any, i: any) => {
        return { ...v, no: i + 1 };
      });
      new AngularCsv(data, 'Baseline History', options);
    } catch (error) {
      console.error(error);
      alert('Occurred');
    }
  }
}
